import { EMPTY_STRING } from '~constants/index'

export const transformEmptyString = (currentValue, originalValue) => originalValue ?? EMPTY_STRING
